import { PureComponent } from 'react'
import { connect } from 'react-redux'
import { Modal, ModalBody } from 'components/modal'
import { Checkbox, Form, Input, FormButtonGroup } from 'components/forms'
import { getRegistryCategory } from 'registry/reducers'
import { deleteCategory } from 'registry/actions/reg-items-actions'

class DeleteCategoryModal extends PureComponent {
  state = {
    submitting: false,
  }

  handleCategoryDelete = (e) => {
    const {
      deleteCategory,
      category: { id },
    } = this.props

    e.preventDefault()
    this.setState({ submitting: true })

    deleteCategory(id).then(() => {
      this.setState({ submitting: false })
      this.props.onHide()
    })
  }

  hideModal = () => {
    this.setState({ submitting: false })
    this.props.onHide()
  }

  render() {
    return (
      <Modal
        onHide={this.hideModal}
        show={this.props.show}
        title="Delete Category"
      >
        <ModalBody>
          <Form onSubmit={this.handleCategoryDelete}>
            <p className="pbl">
              Are you sure you want to delete{' '}
              <strong>{this.props.category.title}</strong>?
              <br />
              Items in this category will be moved to{' '}
              <strong>{this.props.generalCategory.title}</strong>.
            </p>
            <FormButtonGroup
              onClickSecondary={this.hideModal}
              submitting={this.state.submitting}
              textPrimary="Delete Category"
              textSecondary="Cancel"
            />
          </Form>
        </ModalBody>
      </Modal>
    )
  }
}

const mapStateToProps = (state) => ({
  generalCategory: getRegistryCategory(state, 0),
})

export default connect(mapStateToProps, { deleteCategory })(DeleteCategoryModal)
